'use client'

import { GTM_EVENT } from '@/constants'
import { sendGTMEvent } from '@next/third-parties/google'
import { useEffect } from 'react'

export const CategoryPageViewGTMEvent = () => {
  useEffect(() => {
    sendGTMEvent({
      event: GTM_EVENT.CATEGORY_PAGE_VIEW,
      'page path': window.location.href,
    })
  }, [])

  return null
}
